import React from "react";
import { cn } from "../../utils/cn";
import { useTranslation } from "react-i18next";
import { Eye, EyeOff } from "lucide-react";

interface PasswordVisibilityCardProps {
  isPasswordVisible: boolean;
  handleTogglePasswordVisibility: () => void;
}

const PasswordVisibilityCard = ({
  isPasswordVisible,
  handleTogglePasswordVisibility,
}: PasswordVisibilityCardProps) => {
  const { t, i18n } = useTranslation();

  return (
    <div
      className={cn(
        "absolute top-0  z-10 flex items-center gap-1 cursor-pointer",
        i18n.language === "en" ? "right-0" : "left-0"
      )}
      onClick={handleTogglePasswordVisibility}
    >
      {isPasswordVisible ? (
        <EyeOff className="w-5 h-5 text-black-tertiary/80" />
      ) : (
        <Eye className="w-5 h-5 text-black-tertiary/80" />
      )}
      <p className="text-black-tertiary/80 text-[13px]">
        {isPasswordVisible ? t("hide") : t("show")}
      </p>
    </div>
  );
};

export default React.memo(PasswordVisibilityCard);
